import { Card, CardContent, Grid, Stack, Typography } from '@mui/material'
import { push } from '@lagunovsky/redux-react-router'
import { take } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { useDispatch } from 'react-redux'
import i18n from 'simple-react-i18n'
import { greyBlue, lightGrey } from 'utils/constants/ColorTheme'
import { getUser } from 'utils/SettingUtils'
import Table from '../../components/datatable/Table'
import { PATH_DASHBOARD } from '../../home/constants/RouteConstants'
import CampaignDto from '../dto/CampaignDto'
import { NewTable, WrapperCardContent } from 'components/datatable/NewTable'
import { NoDataPanel } from 'components/card/NoDataCard'
import { execByType } from 'utils/StationUtils'
import NaturePeopleIcon from '@mui/icons-material/NaturePeople'

// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated use CampaignPortletPanel
 */
const OldCampaignPortletPanel = ({
    campaigns = [],
    tableHeader = { headers: [] },
    stationType = '',
    noHeader = false,
    customHeaders = {},
    round = false,
}) => {
    const dispatch = useDispatch()

    const user = getUser()
    const orderedCampaigns = [
        ...campaigns.filter(c => c.contactCode === user.contactCode),
        ...campaigns.filter(c => c.contactCode !== user.contactCode),
    ]

    const max3Campaigns = take(orderedCampaigns, 3)

    const title = (
        <a onClick={() => dispatch(push(`/${stationType}/campaign`))}>
            <i className='waves-effect material-icons'>nature_people</i>
            {i18n.currentCampaign}
        </a>
    )

    const headerIcon = (
        <a onClick={() => dispatch(push(`/${stationType}/campaign`))}>
            <i className='waves-effect material-icons'>nature_people</i>
        </a>
    )

    return (
        <div className='row card' style={round ? { borderRadius: 5 } : {}}>
            <div className='row no-margin' id='campaign'>
                <Table
                    showNbElements={!noHeader}
                    showTitle={!noHeader}
                    title={title}
                    showIcon={noHeader}
                    headerIcon={headerIcon}
                    data={max3Campaigns}
                    type={tableHeader}
                    link={`${stationType}/campaign`}
                    subLink={PATH_DASHBOARD}
                    customHeaders={customHeaders}
                    condensed
                    sortable
                    round={round}
                    className='no-box-shadow'
                    noHightlight
                />
            </div>
            {!campaigns.length && (

                <Stack container alignItems='center' justifyContent='center'>
                    <NaturePeopleIcon
                        sx={{
                            fontSize: '80px',
                            cursor: 'pointer',
                        }}
                        onClick={() => dispatch(push(`/${stationType}/campaign`))}
                    />
                    <Typography fontSize='20px'>{i18n.noCampaign}</Typography>
                </Stack>
            )}
            {orderedCampaigns.length > 2 && (
                <div
                    onClick={() => dispatch(push(`/${stationType}/campaign`))}
                    style={{ fontWeight: 'italic', color: greyBlue, borderTop: `solid 1px ${lightGrey}`, fontStyle: '14.3px' }}
                >
                    <div className='padding-right-1 right clickable'>
                        {i18n.viewMore} {'>'}
                    </div>
                </div>
            )}
        </div>
    )
}

OldCampaignPortletPanel.propTypes = {
    campaigns: PropTypes.arrayOf(PropTypes.instanceOf(CampaignDto)),
    tableHeader: PropTypes.shape({
        headers: PropTypes.arrayOf(PropTypes.string),
    }),
    stationType: PropTypes.string.isRequired,
    noHeader: PropTypes.bool,
    customHeaders: PropTypes.arrayOf(PropTypes.shape({})),
    round: PropTypes.bool,
}

const CampaignPortletPanel = ({
    campaigns = [],
    headers = [],
    stationType = '',
    noHeader,
}) => {
    const dispatch = useDispatch()

    const noDataLabel = () => {
        return execByType(stationType, {
            hydrometry: () => i18n.noCurrentHydrometryCampaigns,
            piezometry: () => i18n.noCurrentPiezometryCampaigns,
            pluviometry: () => i18n.noCurrentPluviometryCampaigns,
            quality: () => i18n.noCurrentQualityCampaigns,
            default: () => i18n.noCurrentCampaign,
        })
    }

    return (
        <Card>
            <CardContent sx={{ padding: '5px 0 0' }}>
                <Grid container>
                    <Grid size={12}>
                        <NewTable
                            rows={take(campaigns, 3)}
                            headers={headers}
                            onClickRow={({ id }) => dispatch(push(`/${stationType}/campaign/${id}`))}
                            WrapperComponent={WrapperCardContent}
                            noDataDisplay={<NoDataPanel message={noDataLabel()} />}
                            displayHeaders={!noHeader}
                        />
                    </Grid>
                    {campaigns.length > 3 && (
                        <Grid size={12} sx={{ display: 'flex', justifyContent: 'right', padding: '0 5px' }}>
                            <div
                                onClick={() => dispatch(push(`/${stationType}/campaign`))}
                                style={{ color: greyBlue, fontStyle: '14px', cursor: 'pointer', marginRight: '10px' }}
                            >
                                {i18n.viewMore} {'>'}
                            </div>
                        </Grid>
                    )}
                </Grid>
            </CardContent>
        </Card>
    )
}

CampaignPortletPanel.propTypes = {
    campaigns: PropTypes.arrayOf(PropTypes.shape({
        contactCode: PropTypes.number,
    })),
    headers: PropTypes.array,
    stationType: PropTypes.string,
    noHeader: PropTypes.bool,
}

export default CampaignPortletPanel
export { OldCampaignPortletPanel }